/**
 * Custom JS for Plastics Co UK
 */

// ===== AMAZON-STYLE SHRINKING STICKY HEADER =====
// pco 2026-09-14 v2. The header section keeps its full height in the page flow, so nothing below it
// moves. Once the page has scrolled by the height of the menu row + promo bar (--pco-collapsible),
// layout CSS pins the section at that negative offset and reorders those two parts ABOVE the logo
// row, leaving only the logo/search/cart row on screen. The switch happens exactly where the
// section's natural position meets its pinned position, so it is seamless in both directions.
// Hysteresis keeps it from flapping; the only flow change is the theme's own padding shrink on
// the logo row, and any residual page shift from that is measured and scrolled away.
(function() {
  var html = document.documentElement;
  var isScrolled = false;
  var ticking = false;
  var collapsible = 0;
  var collapseAt = 0;

  function section() { return document.querySelector('.shopify-section__header'); }
  function logoRow() { return document.querySelector('.shopify-section__header .header'); }
  function contentRef() { return document.querySelector('main') || document.body; }

  // Natural document position of the (sticky) section. offsetTop/getBoundingClientRect on a stuck
  // sticky element report its pinned position, so derive it from the parent plus in-flow siblings.
  function docTop(el) {
    var p = el.parentElement;
    if (!p) return 0;
    var t = p.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    var s = p.firstElementChild;
    while (s && s !== el) {
      var cs = getComputedStyle(s);
      if (cs.position !== 'absolute' && cs.position !== 'fixed' && cs.display !== 'none') {
        t += s.getBoundingClientRect().height;
      }
      s = s.nextElementSibling;
    }
    return t;
  }

  function measureCollapsible() {
    var sec = section(), row = logoRow();
    if (!sec || !row) return 0;
    var h = sec.offsetHeight - row.offsetHeight;
    return h > 0 ? h : 0;
  }

  function syncHeaderHeight() {
    var el = isScrolled ? logoRow() : section();
    if (el) html.style.setProperty('--header-height', el.offsetHeight + 'px');
  }

  function apply(scrolled) {
    var ref = contentRef();
    var y0 = window.scrollY || window.pageYOffset;
    var r0 = ref.getBoundingClientRect().top;
    isScrolled = scrolled;
    if (scrolled) {
      html.style.setProperty('--pco-collapsible', collapsible + 'px');
      html.classList.add('header-scrolled');
      var r1 = ref.getBoundingClientRect().top;
      var shift = r1 - r0;
      if (Math.abs(shift) > 1) window.scrollBy(0, shift);
    } else {
      html.classList.remove('header-scrolled');
      ref.getBoundingClientRect();
      if ((window.scrollY || window.pageYOffset) !== y0) window.scrollTo(0, y0);
    }
    syncHeaderHeight();
  }

  function check() {
    var y = window.scrollY || window.pageYOffset;
    if (!isScrolled) {
      // Switch exactly where the section, scrolling naturally, reaches its pinned offset: its
      // document position (below the announcement bar) plus the collapsible height.
      collapsible = measureCollapsible();
      var sec = section();
      collapseAt = (sec ? docTop(sec) : 0) + collapsible;
      if (collapsible > 0 && y >= collapseAt) apply(true);
    } else if (y < collapseAt - 50) {
      apply(false);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    // setTimeout, not requestAnimationFrame: rAF never fires in a background tab, which would leave
    // `ticking` stuck and the header frozen once the tab is shown.
    setTimeout(function() { ticking = false; check(); }, 40);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function() { syncHeaderHeight(); onScroll(); }, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
// ===== END SHRINKING HEADER =====

// ===== WHATSAPP FLOATING BUTTON =====
(function() {
  var style = document.createElement('style');
  style.textContent = '.pco-wa-btn{position:fixed;bottom:24px;right:24px;z-index:9999;width:54px;height:54px;background:#25D366;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 16px rgba(37,211,102,0.4);cursor:pointer;text-decoration:none;transition:transform 0.2s,box-shadow 0.2s;}.pco-wa-btn:hover{transform:scale(1.08);box-shadow:0 6px 20px rgba(37,211,102,0.5);}@media(max-width:640px){.pco-wa-btn{bottom:16px;right:16px;width:48px;height:48px;}}';
  document.head.appendChild(style);

  var a = document.createElement('a');
  a.className = 'pco-wa-btn';
  a.target = '_blank';
  a.rel = 'noopener';
  a.setAttribute('aria-label', 'Chat on WhatsApp');
  a.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="#ffffff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

  var msg = 'Hi, I would like to enquire about: ' + window.location.href;
  a.href = 'https://wa.me/447822012977?text=' + encodeURIComponent(msg);

  if (document.body) {
    document.body.appendChild(a);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.appendChild(a);
    });
  }
})();
// ===== END WHATSAPP BUTTON =====

// ===== PRODUCT PAGE TABS (Description | Delivery & Returns | Trade & Bulk) =====
(function() {
  function injectTabs() {
    // Only on product pages
    if (!document.body.classList.contains('template-product')) return;

    var descBlock = document.querySelector('.product-block-list__item--description');
    if (!descBlock) return;
    if (descBlock.getAttribute('data-tabs-injected')) return; // already done
    descBlock.setAttribute('data-tabs-injected', '1');

    // Get existing description content
    var descContent = descBlock.querySelector('.rte, .card__section');
    var descHtml = descContent ? descContent.innerHTML : '';

    // Delivery & Returns HTML
    var deliveryHtml = '<div class="pco-delivery-grid">' +
      '<div class="pco-delivery-item"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f4c89" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><div><strong>UK Delivery</strong><p>Standard delivery to UK mainland addresses, with the cost shown at checkout.</p></div></div>' +
      '<div class="pco-delivery-item"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f4c89" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><div><strong>Same-Day Dispatch</strong><p>Orders before 2pm (Mon–Fri) dispatched same day from our UK warehouse.</p></div></div>' +
      '<div class="pco-delivery-item"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f4c89" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg><div><strong>Delivery Timescales</strong><p>Standard delivery in 1–3 working days. Need it sooner? Call 01744 520110.</p></div></div>' +
      '<div class="pco-delivery-item"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f4c89" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg><div><strong>Returns Policy</strong><p>14-day returns on unopened stock items. Cut-to-size orders non-returnable unless faulty. <a href="/policies/refund-policy">See policy</a></p></div></div>' +
      '</div>';

    // Trade & Bulk HTML
    var tradeHtml = '<div class="pco-trade-panel">' +
      '<div class="pco-trade-icon"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#157a56" stroke-width="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg></div>' +
      '<h3>Trade & Bulk Pricing Available</h3>' +
      '<p>We supply manufacturers, engineers and fabricators across the UK. Larger quantities or regular orders? We’d love to help.</p>' +
      '<ul class="pco-trade-list"><li>Volume discounts from as little as 5 items</li><li>Account terms for established businesses</li><li>Regular call-off orders arranged</li><li>Technical material selection support included</li></ul>' +
      '<div class="pco-trade-cta">' +
      '<a href="tel:01744520110" class="pco-trade-btn pco-trade-btn--primary"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.04 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16z"/></svg>Call 01744 520110</a>' +
      '<a href="mailto:sales@plasticsco.co.uk" class="pco-trade-btn pco-trade-btn--secondary">Email for a Quote</a>' +
      '</div></div>';

    // Build tab UI
    var uid = 'pco-tabs-' + Date.now();
    var tabsHtml =
      '<div class="pco-tabs" id="' + uid + '">' +
        '<div class="pco-tabs__nav" role="tablist">' +
          '<button class="pco-tab pco-tab--active" role="tab" aria-selected="true" data-target="desc">Description</button>' +
          '<button class="pco-tab" role="tab" aria-selected="false" data-target="delivery">Delivery &amp; Returns</button>' +
          '<button class="pco-tab" role="tab" aria-selected="false" data-target="trade">Trade &amp; Bulk</button>' +
        '</div>' +
        '<div class="pco-tabs__content">' +
          '<div class="pco-tab-panel pco-tab-panel--active rte" data-panel="desc">' + descHtml + '</div>' +
          '<div class="pco-tab-panel" data-panel="delivery" style="display:none">' + deliveryHtml + '</div>' +
          '<div class="pco-tab-panel" data-panel="trade" style="display:none">' + tradeHtml + '</div>' +
        '</div>' +
      '</div>';

    // Replace description block content with tabs
    descBlock.innerHTML = tabsHtml;

    // Tab click handler
    var container = document.getElementById(uid);
    container.querySelectorAll('.pco-tab').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-target');
        container.querySelectorAll('.pco-tab').forEach(function(b) {
          b.classList.remove('pco-tab--active');
          b.setAttribute('aria-selected', 'false');
        });
        container.querySelectorAll('.pco-tab-panel').forEach(function(p) {
          p.classList.remove('pco-tab-panel--active');
          p.style.display = 'none';
        });
        btn.classList.add('pco-tab--active');
        btn.setAttribute('aria-selected', 'true');
        var panel = container.querySelector('[data-panel="' + target + '"]');
        if (panel) { panel.classList.add('pco-tab-panel--active'); panel.style.display = 'block'; }
      });
    });
  }

  // Inject CSS
  var tabStyle = document.createElement('style');
  tabStyle.textContent = [
    '.pco-tabs{margin:18px 0;}',
    '.pco-tabs__nav{display:flex;border-bottom:2px solid #e0e0e0;gap:0;margin-bottom:0;overflow-x:auto;}',
    '.pco-tab{padding:10px 16px;font-size:13.5px;font-weight:600;color:#666;background:none;border:none;border-bottom:2.5px solid transparent;margin-bottom:-2px;cursor:pointer;transition:color 0.15s,border-color 0.15s;white-space:nowrap;font-family:inherit;}',
    '.pco-tab:hover{color:#0f4c89;}',
    '.pco-tab--active{color:#0f4c89;border-bottom-color:#0f4c89;}',
    '.pco-tabs__content{padding:18px 0 0;}',
    '.pco-tab-panel{font-size:14px;line-height:1.7;color:#333;}',
    '.pco-delivery-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;}',
    '.pco-delivery-item{display:flex;gap:12px;align-items:flex-start;}',
    '.pco-delivery-item svg{flex-shrink:0;margin-top:2px;}',
    '.pco-delivery-item strong{display:block;font-size:13.5px;color:#1a1a1a;margin-bottom:3px;}',
    '.pco-delivery-item p{font-size:12.5px;color:#555;margin:0;line-height:1.5;}',
    '.pco-trade-panel{text-align:center;padding:20px;background:#f8fdf9;border-radius:8px;border:1px solid #d0ece3;}',
    '.pco-trade-icon{margin-bottom:12px;}',
    '.pco-trade-panel h3{font-size:17px;color:#0f4c89;margin:0 0 10px;font-weight:700;}',
    '.pco-trade-panel>p{font-size:13.5px;color:#444;margin:0 0 14px;line-height:1.6;}',
    '.pco-trade-list{text-align:left;display:inline-block;margin:0 0 18px;padding:0;list-style:none;}',
    '.pco-trade-list li{font-size:13px;color:#333;padding:3px 0;}',
    '.pco-trade-list li::before{content:"✓ ";color:#157a56;font-weight:700;}',
    '.pco-trade-cta{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;}',
    '.pco-trade-btn{display:inline-flex;align-items:center;gap:6px;padding:10px 20px;border-radius:6px;font-size:13.5px;font-weight:600;text-decoration:none;transition:all 0.15s;}',
    '.pco-trade-btn--primary{background:#0f4c89;color:#fff;}',
    '.pco-trade-btn--primary:hover{background:#0d3d72;color:#fff;}',
    '.pco-trade-btn--secondary{background:#fff;color:#0f4c89;border:1.5px solid #0f4c89;}',
    '.pco-trade-btn--secondary:hover{background:#f0f5fb;}',
    '@media(max-width:600px){.pco-delivery-grid{grid-template-columns:1fr;}.pco-tab{padding:9px 10px;font-size:12.5px;}}'
  ].join('');
  document.head.appendChild(tabStyle);

  // Run on DOMContentLoaded and after Shopify re-renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTabs);
  } else {
    injectTabs();
  }

  // Re-run after variant changes (Shopify re-renders the product form)
  document.addEventListener('variant:changed', function() {
    setTimeout(injectTabs, 300);
  });
})();
// ===== END PRODUCT TABS =====
